var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],ref:"popoverRef",class:['popover-container', { open: _vm.open }]},[_vm._t("trigger"),_c('transition',{attrs:{"name":"fade"}},[(_vm.open)?_c('div',{class:[
                'popover',
                'popover-' + _vm.align,
                'popover-' + _vm.size,
                'popover-on-' + _vm.position,
                { 'has-caret': _vm.hasCaret }
            ],style:(_vm.offsetStyle)},[_vm._t("content")],2):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }